import { render, staticRenderFns } from "./AppButtons.vue?vue&type=template&id=5d5ab268&scoped=true&"
import script from "./AppButtons.vue?vue&type=script&lang=js&"
export * from "./AppButtons.vue?vue&type=script&lang=js&"
import style0 from "./AppButtons.vue?vue&type=style&index=0&id=5d5ab268&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d5ab268",
  null
  
)

export default component.exports